// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "464e01e0d90cc31c9fc558fa792a9559",
  base: "https://api.openweathermap.org/data/2.5/",
};
